export enum ActionTime {
  DAYS = "days",
  MINUTES = "minutes",
};

